module.exports = __webpack_public_path__ + "static/media/Bumppy Payments3.b323f715.png";